export var envVars = {
    DEFAULT_LOCALE: 'en-US',
    SUPPORTED_LOCALES: ['en-US', 'fr-CA', 'ja-JP'],
};
